import { useEffect, useRef } from 'react';
import './StreamingTextView.css';

type Props = {
  text: string;
  streaming?: boolean;
  className?: string;
};

export default function StreamingTextView({ text, streaming, className }: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (streaming && ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [text, streaming]);

  return (
    <div ref={ref} className={`streaming-text ${className ?? ''}`}>
      {text || (streaming ? '…' : <span className="dim">(empty)</span>)}
      {streaming && <span className="streaming-caret">▍</span>}
    </div>
  );
}
